import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from "react";
import { FunctionEditComponents } from "./functionEditComponent";
import CaseUpdateForm from "./caseUpdateForm";
/** <b>Composant en mode consultation/detail d'un champ de type function</b>*/
/* eslint-disable */
export default function FunctionFieldEdit(_a) {
    var fieldName = _a.fieldName, fieldDef = _a.fieldDef, record = _a.record, onUpdate = _a.onUpdate, moduleName = _a.moduleName, viewType = _a.viewType, fieldMetadata = _a.fieldMetadata;
    var value = useMemo(function () {
        if (!fieldDef[fieldName]["value"]) {
            return;
        }
        return fieldDef[fieldName]["value"] || "";
    }, [fieldName, fieldDef]);
    if (fieldName === "aop_case_updates_threaded") {
        return (_jsx(_Fragment, { children: _jsx(CaseUpdateForm, { viewType: viewType, record: record, moduleName: moduleName, fieldName: fieldName, onUpdate: onUpdate, fieldMetadata: fieldMetadata, fieldDef: fieldDef }) }));
    }
    else {
        return (_jsx(_Fragment, { children: _jsx(FunctionEditComponents, { fieldName: fieldName, viewType: viewType, record: record, onUpdate: onUpdate, moduleName: moduleName, fieldDef: fieldDef }) }));
    }
}
